var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row mb-4 pl-3" },
    [
      _vm.showEdit
        ? [
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("validation-provider", {
                  attrs: { name: "Teléfono", rules: "required|length:11" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "Campo Requerido",
                                error: errors[0],
                                label: "Teléfono:",
                                "mask-type": "Phone",
                                placeholder: "(___) ___-____"
                              },
                              model: {
                                value: _vm.model.locationTelephoneNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "locationTelephoneNo",
                                    $$v
                                  )
                                },
                                expression: "model.locationTelephoneNo"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2237919540
                  )
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("custom-input", {
                  attrs: {
                    label: "Fax:",
                    "mask-type": "Phone",
                    placeholder: "(___) ___-____"
                  },
                  model: {
                    value: _vm.model.locationTelephoneFaxNo,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationTelephoneFaxNo", $$v)
                    },
                    expression: "model.locationTelephoneFaxNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("custom-input", {
                  attrs: {
                    label: "Dirección Web:",
                    placeholder: "www.websitedomain.com"
                  },
                  model: {
                    value: _vm.model.locationWebsiteUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationWebsiteUrl", $$v)
                    },
                    expression: "model.locationWebsiteUrl"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm d-flex align-items-end" },
              [_vm._t("default")],
              2
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "col-4 my-2" },
              [
                _c("custom-input-display", {
                  attrs: {
                    label: "Teléfono:",
                    "mask-type": "Phone",
                    placeholder: "(___) ___-____"
                  },
                  model: {
                    value: _vm.model.locationTelephoneNo,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationTelephoneNo", $$v)
                    },
                    expression: "model.locationTelephoneNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-4 my-2" },
              [
                _c("custom-input-display", {
                  attrs: {
                    label: "Fax:",
                    "mask-type": "Phone",
                    placeholder: "(___) ___-____"
                  },
                  model: {
                    value: _vm.model.locationTelephoneFaxNo,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationTelephoneFaxNo", $$v)
                    },
                    expression: "model.locationTelephoneFaxNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-4 my-2" },
              [
                _c("custom-input-display", {
                  attrs: { label: "Dirección Web:" },
                  model: {
                    value: _vm.model.locationWebsiteUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "locationWebsiteUrl", $$v)
                    },
                    expression: "model.locationWebsiteUrl"
                  }
                })
              ],
              1
            ),
            _vm.isMedicaidDocumentationWorkflowEnabled
              ? _c(
                  "div",
                  { staticClass: "col-4 my-2" },
                  [
                    _vm.showSchoolSection
                      ? _c("custom-input-display", {
                          attrs: {
                            label: "NPI LS DEPR:",
                            value: _vm.model.locationSchoolNationalIdentifier
                          }
                        })
                      : _c("validation-provider", {
                          ref: "npiDeprObserver",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        class: {
                                          "ml-3": !_vm.isNpiDeprDisabled
                                        }
                                      },
                                      [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "El NPI LS DEPR es requerido.",
                                            disabled: _vm.isNpiDeprDisabled,
                                            error: errors[0],
                                            label: "NPI LS DEPR:"
                                          },
                                          model: {
                                            value:
                                              _vm.model
                                                .locationSchoolNationalIdentifier,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "locationSchoolNationalIdentifier",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "model.locationSchoolNationalIdentifier"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "ml-2",
                                            class: { "mt-4": !errors?.length }
                                          },
                                          [
                                            _vm.editingNpiDepr
                                              ? _c("div", [
                                                  _vm.canCancelNpiDepr &&
                                                  _vm.initialNpiDepr
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "ab-btn ab-btn-outline-danger mt-1 mr-2",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.cancelEditNpiDepr
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-times-circle"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "ab-btn ab-btn-success mt-1",
                                                      attrs: {
                                                        disabled:
                                                          !!errors?.length ||
                                                          _vm.initialNpiDepr ==
                                                            _vm.model
                                                              .locationSchoolNationalIdentifier,
                                                        type: "button"
                                                      },
                                                      on: {
                                                        click: _vm.saveNpiDepr
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-save"
                                                      })
                                                    ]
                                                  )
                                                ])
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "ab-btn ab-btn-success mt-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.editNpiDepr
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fas fa-edit"
                                                    })
                                                  ]
                                                )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3614768520
                          )
                        })
                  ],
                  1
                )
              : _vm._e(),
            _vm.isMedicaidDocumentationWorkflowEnabled
              ? _c(
                  "div",
                  { staticClass: "col-4 my-2" },
                  [
                    _c("validation-provider", {
                      ref: "npiObserver",
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex align-items-center",
                                    class: { "ml-3": !_vm.isNpiDisabled }
                                  },
                                  [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El NPI es requerido.",
                                        disabled: _vm.isNpiDisabled,
                                        error: errors[0],
                                        label: "NPI LS Proveedor:"
                                      },
                                      model: {
                                        value: _vm.model.nationalIdentifier,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "nationalIdentifier",
                                            $$v
                                          )
                                        },
                                        expression: "model.nationalIdentifier"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2",
                                        class: { "mt-4": !errors?.length }
                                      },
                                      [
                                        _vm.editingNpi
                                          ? _c("div", [
                                              _vm.canCancelNpi && _vm.initialNpi
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "ab-btn ab-btn-outline-danger mt-1 mr-2",
                                                      attrs: {
                                                        type: "button",
                                                        variant:
                                                          "outline-danger mt-1 mr-2"
                                                      },
                                                      on: {
                                                        click: _vm.cancelEditNpi
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-times-circle"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "ab-btn ab-btn-success mt-1",
                                                  attrs: {
                                                    disabled:
                                                      !!errors?.length ||
                                                      _vm.initialNpi ==
                                                        _vm.model
                                                          .nationalIdentifier,
                                                    type: "button"
                                                  },
                                                  on: { click: _vm.saveNpi }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-save"
                                                  })
                                                ]
                                              )
                                            ])
                                          : _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "ab-btn ab-btn-success mt-1",
                                                attrs: { type: "button" },
                                                on: { click: _vm.editNpi }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-edit"
                                                })
                                              ]
                                            )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3111110734
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }